import React, { useEffect, useState } from "react";
import CustomDrawer from "../../controls/CustomDrawer";
import Button from "../../controls/Button";
import Input from "../../controls/Input";
import ImageUpload from "../../controls/ImageUpload";
import CustomSwitch from "../../controls/CustomSwitch";
import ColorPicker from "../../controls/ColorPicker";
import Select from "../../controls/Select";
import { toast } from "react-toastify";
import AxiosAPI from "../../../api/AxiosAPI";
import { handleAddSubCategory, handleEditSubCategory } from "../../../api/subCategoryApi";
import { fetchCategory } from "../../../api/CategoryApi";
import { uploadImagesToServer } from "../../../../uploadImageToServer";
import Loading from "../../controls/Loading";
import Autocompletesearch from "../../controls/Autocompletesearchbk";
import ConfirmBox from "../../controls/ConfirmBox";

const AddSubCategory = ({
  closeDrawer,
  onSave,
  editData = {},
  categoryID,
  categoryName
}) => {
  console.log("cateogyrID", categoryID, categoryName);
  const [name, setName] = useState(editData?.Name || "");
  const [parent, setParent] = useState(editData?.Parent || categoryName || "");
  const [parentId, setParentId] = useState(editData?.ParentID || categoryID || "");
  const [sequence, setSequence] = useState(editData?.Sequence || "");
  const [image, setImage] = useState(editData?.Image?.Preview || "");
  const [imageFileName, setImageFileName] = useState(editData?.Image?.Name || "");
  const [imageSize, setImageSize] = useState(editData?.Image?.Size || 0);
  const [color, setColor] = useState(editData?.Color || "#ffffff");

  const [imageUploading, setImageUploading] = useState(false);
  const [parentError, setParentError] = useState("");
  const [nameError, setNameError] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [OMNIEnabled,setOMNIEnabled]=useState(editData?.OMNIEnabled || false);



  const handleImageUpload = async (imageFile) => {
    setImageUploading(true);
    try {
      const uploadurl = await uploadImagesToServer(imageFile);
      if (uploadurl) {
        setImage(uploadurl);
      }
    } catch (error) {
      console.error("Image upload failed:", error);
      toast.error("Failed to upload image");
    } finally {
      setImageUploading(false);
    }
  };

  const handleSaveClick = async () => {
    let hasError = false;
    if(imageUploading){
      toast.info("Please wait for uploading image then try...");
      return;
    }

    if (name.trim() === "") {
      setNameError("Please enter sub category name");
      hasError = true;
    }

    if (parent.trim() === "") {
      setParentError("Please select category");
      hasError = true;
    }

    if (hasError) {
      return;
    }

    setLoading(true);
      let omniTag = '', category = '', subCategory = '';
    category = parent.replace(/[@!&\/\\#,+()$~%.'"`_:*?<>{}-]/g, '').replace(/[' ']/g,'_');
            subCategory = name.replace(/[@!&\/\\#,+()$~%.'"`_:*?<>{}-]/g, '').replace(/[' ']/g,'_');
            omniTag = category + '_' + subCategory
    const payload = {
      Parent: parent,
      ParentID: parentId,
      Color: color,
      Sequence: Number(sequence) || 0,
      Name: name.trim(),
      Image: {
        Preview: image,
        Name: imageFileName,
        Size: imageSize
      },
      IsDeleted:false,
        OMNITag:omniTag,
            BackEndUpdate: false ,
            OMNIEnabled:OMNIEnabled,
      ...(editData.key && { key: editData.key }),
    };


    try {
      setLoading(true);
      let response = null;

      if (editData?.key) {
        response = await handleEditSubCategory(payload);
      } else {
        response = await handleAddSubCategory(payload);
      }

      if (response?.code === "0") {
        toast.success(editData?.key ? "Sub category updated successfully" : "Sub category added successfully");
        closeDrawer(false);
        setLoading(false);
        console.log("respionse",response);
        onSave(response?.category);
      } else {
        console.error("Failed to save sub category:", response);
        toast.error("Failed to save sub category", response?.data?.message);
        setLoading(false);
      }
    }
    catch (error) {
      console.error("Failed to save sub category:", error);
      toast.error("Failed to save sub category", error);
      setLoading(false);
    }


  };

  const fetchCategoriesData = async () => {
    try {
      const response = await fetchCategory();
        const allCategories = response.productCategories.filter(
              (e) => !e.IsDeleted);
      const formattedCategories = allCategories.map(item => ({
        ...item,
        label: item.Name,
        value: item.key
      }));
      setCategoryData(formattedCategories);
    } catch (err) {
      console.error("Error fetching categories:", err);
      toast.error("Failed to load categories");
      setCategoryData([]);
    }
  };

  useEffect(() => {
    fetchCategoriesData();
  }, []);

  return (
    <CustomDrawer
      setDrawer={closeDrawer}
      title={editData?.key ? "Edit Sub Category" : "Add Sub Category"}
      drawerType="medium"
      buttons={[
        { Label: "Cancel", Type: "secondary", Icon: "roundedRemove" },
        { Label: "Save", Type: "primary", Icon: "save" },
      ]}
      onButtonClick={(label) => {
        if (label === "Save") handleSaveClick();
        else if (label === "Cancel") closeDrawer(false);
      }}
    >
      {loading ? (
        <Loading />
      ) : (
        <div className="flex flex-col gap-4">
          <Autocompletesearch
            isMandatory={true}
            value={parent}
            defaultDataCount={20}
            label="Category"
            data={categoryData}
            filterKey={["label"]}
            onChange={(value) => {
              setParent("");
              setParentId("");
            }}
            onSelect={(selectedItem) => {
              setParent(selectedItem.label);
              setParentId(selectedItem.value);
              setParentError("");
            }}
            placeholder="Select Category"
            renderSuggestion={(item) => (
              <div>
                <p className="">{item.label}</p>
              </div>
            )}
            errormessage={parentError}
          />

          <Input
            isMandatory={true}
            label="Sub Category Name"
            placeholder="Sub Category Name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setNameError("");
            }}
            errorMessage={nameError}
          />
          <div className="w-[50%]">
            <Input
              label="Sequence"
              placeholder="Sequence"
              type="number"
              value={sequence}
              onChange={(e) => setSequence(e.target.value)}
            />
          </div>

          {imageUploading ? (
            <p>Uploading...</p>
          ) : (
            <ImageUpload
              title={"Image"}
              onImagedelete={() => {
                setImage(null);
                setImageFileName("");
                setImageSize(0);
              }}
              onImageChange={handleImageUpload}
              imageData={image}
              onFileInfoChange={(fileInfo) => {
                if (fileInfo) {
                  setImageFileName(fileInfo.name);
                  setImageSize(fileInfo.size);
                } else {
                  setImageFileName("");
                  setImageSize(0);
                }
              }}
            />
          )}

          <ColorPicker
            value={color}
            onChange={(newColor) => setColor(newColor)}
          />
            <CustomSwitch
              formlabel="Show Online"
              checked={OMNIEnabled}
              onChange={(checked) => setOMNIEnabled(checked)}
            />
        </div>
      )}
    </CustomDrawer>
  );
};

export default AddSubCategory;